(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name baseWiseLayoverReport.controller:BaseWiseLayoverReportCtrl
   *
   * @description
   *
   */
  angular
    .module('baseWiseLayoverReport')
    .controller('BaseWiseLayoverReportCtrl', BaseWiseLayoverReportCtrl);

  function BaseWiseLayoverReportCtrl(CommonMasterData, crewScheduleService,RemoteService,$sce,MessageService, CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'BaseWiseLayoverReportCtrl';

	vm.model = {
			searchPanelToggle : true,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				crewType : null,
				crewName : null,
				datePickerOption : {maxDate : new Date()}
			},
			masterList : {
				crewTypeList : [],
				fromDateAfterToDate : false,
				fromDateToDateAfterToDay : false,
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false
			},
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl :null,
			gmtOff : 0
		};

		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search
		vm.submitSearch = function(params) {
			searchBaseWiseLayOver(params);
		};

		// on change search field
		vm.changeSearchField = function(searchParams, flag) {
			setDateValidationFlags();
			
			if(flag == 'fromDate'&& !!searchParams.fromDate){
				if(!vm.model.masterList.fromDateFormatInvalid && !isDateBeforeCurrentDate(searchParams.fromDate)){
					vm.model.masterList.fromDateToDateAfterToDay = true;
				}else if(!vm.model.masterList.toDateFormatInvalid && isDateBeforeCurrentDate(searchParams.toDate)){
					vm.model.masterList.fromDateToDateAfterToDay = false;
				}
			}else if(flag == 'toDate'&& !!searchParams.toDate){
				if(!vm.model.masterList.toDateFormatInvalid && !isDateBeforeCurrentDate(searchParams.toDate)){
					vm.model.masterList.fromDateToDateAfterToDay = true;
				}else if(!vm.model.masterList.fromDateFormatInvalid && isDateBeforeCurrentDate(searchParams.fromDate)){
					vm.model.masterList.fromDateToDateAfterToDay = false;
				}
			}
			if(!vm.model.masterList.toDateFormatInvalid && !vm.model.masterList.fromDateFormatInvalid){
				if(istoDateBeforeFromDate()){
					vm.model.masterList.fromDateAfterToDate = true;
				}else{
					vm.model.masterList.fromDateAfterToDate = false;
				}
			}else{
				vm.model.masterList.fromDateToDateAfterToDay = false;
				vm.model.masterList.fromDateAfterToDate = false;
			}
		};

		function setDateValidationFlags(){
			//if from date invalid
			if(isDateFormatInvalid(vm.model.searchCriteria.fromDate)){
				vm.model.masterList.fromDateFormatInvalid = true;
			}else{
				vm.model.masterList.fromDateFormatInvalid = false;
			}

			//if to date invalid
			if(isDateFormatInvalid(vm.model.searchCriteria.toDate)){
				vm.model.masterList.toDateFormatInvalid = true;
			}else{
				vm.model.masterList.toDateFormatInvalid = false;
			}
		}

		function isDateFormatInvalid(date){
			if(!!date && !moment(date, "DD/MM/YYYY").isValid()){
				return true;
			}
			return false;
		}


		// check from date and to date
		function istoDateBeforeFromDate() {
			return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
					.isBefore(
							moment(vm.model.searchCriteria.fromDate,
									"DD/MM/YYYY"));
		}
		;

		function isDateBeforeCurrentDate(strDate){
			if(moment(strDate, "DD/MM/YYYY")
					.isAfter(new Date())){
				return false;
			}
			return true;

		}

		// load crew list

		// load search electronic log book
		function searchBaseWiseLayOver(param) {
			vm.model.initialSearchDone = true;
			if (isValidSearchParams(param)) {
				vm.model.searchCriteria = param;
				vm.model.searchPanelToggle = false;
		    	var url = CommonLogicService.getReportUrl('base_wise_layover.rptdesign',getSearchParamMap(param));
		    	vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
			}
		}

		//set search param map
		function getSearchParamMap(param){
			var searchParamMap = {};
			searchParamMap["fromDate"] = param.fromDate;
			searchParamMap["toDate"] = param.toDate;
			searchParamMap["crewType"]= param.crewType.crewTypeCode;
			return searchParamMap;
		}

		function isValidSearchParams(params) {
			setDateValidationFlags();
			// if date invalid
			if(vm.model.masterList.toDateFormatInvalid || vm.model.masterList.fromDateFormatInvalid){
				return false;
			}
			if(!isDateBeforeCurrentDate(params.toDate) || !isDateBeforeCurrentDate(params.fromDate)){
				vm.model.masterList.fromDateToDateAfterToDay = true;
				vm.model.masterList.fromDateAfterToDate = false;
				vm.model.masterList.isCrewAvailable = true;
				return false;
			} else if (istoDateBeforeFromDate()) {
				vm.model.masterList.fromDateToDateAfterToDay = false;
				vm.model.masterList.fromDateAfterToDate = true;
				vm.model.masterList.isCrewAvailable = true;
				return false;
			}
			return true;
		}

		(function() {
				// crew type master codes
				CommonMasterData.getCrewTypeList(function(crewTypeList) {
					vm.model.masterList.crewTypeList = crewTypeList;
				}, function() {
					console.log('Crew Type list retrieval error');
				});

				//get Gmt off
				CommonMasterData.getGmtOff(function(gmtOff) {
					vm.model.gmtOff = gmtOff;
				}, function(error) {
					MessageService.error(error);
				});

		})();


  }
}());
